var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficultyOrChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 104,
    viewBox: "0 0 80 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Gold Medal",
    filter: "url(#filter0_d_3684_50774)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M30.1445 57.4512L39.7563 63.0005L20.2379 96.8073L14.6357 84.3132L30.1445 57.4512Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3",
    d: "M30.1445 57.4512L20.5328 51.9018L1.0144 85.7087L14.6357 84.3132L30.1445 57.4512Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 6",
    d: "M43.8574 57.4512L34.2457 63.0005L53.7641 96.8073L59.3662 84.3132L43.8574 57.4512Z",
    fill: "#983535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7",
    d: "M43.8574 57.4512L53.4692 51.9018L72.9876 85.7087L59.3662 84.3132L43.8574 57.4512Z",
    fill: "#CE4444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 36.7066,
    cy: 34.1734,
    r: 33.3829,
    fill: "url(#paint0_linear_3684_50774)",
    stroke: "#765C00",
    strokeWidth: 0.583067
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 36.7058,
    cy: 34.1746,
    r: 25.8308,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 52,
    height: 52
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 38.0843,
    cy: 36.9319,
    r: 25.8909,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50774)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 36.7034,
    cy: 34.1741,
    r: 25.8909,
    fill: "#C09525"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.845 16.1621L42.43 27.3322L53.6001 28.7284L45.93 37.3294L48.015 49.6723L36.845 44.0873L25.6749 49.6723L27.7786 37.3294L20.0898 28.7284L31.2599 27.3322L36.845 16.1621Z",
    fill: "url(#paint1_linear_3684_50774)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50774",
    x: 0.55684,
    y: 0.0412147,
    width: 79.2839,
    height: 103.618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.19782,
    dy: 3.19782
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.82733
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50774",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50774",
    x1: 36.7066,
    y1: 1.08203,
    x2: 36.7066,
    y2: 67.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50774",
    x1: 36.845,
    y1: 16.1621,
    x2: 36.845,
    y2: 49.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficultyOrChallenge);
export default __webpack_public_path__ + "static/media/Difficulty_or_challenge.ab265c6a9af4a60df9928b8854685e7a.svg";
export { ForwardRef as ReactComponent };